import React from 'react';

const ImportSummary = ({ selectedCount, importing, onImport, onAIParseAll, parsing, parseProgress }) => {
  const renderParsingState = () => {
    if (parseProgress?.totalBatches > 0) {
      return (
        <>
          <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white"></div>
          Parsing batch {parseProgress.currentBatch}/{parseProgress.totalBatches}...
        </>
      );
    }
    return (
      <>
        <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white"></div>
        Parsing {parseProgress.current}/{parseProgress.total}...
      </>
    );
  };

  return (
    <div className="mb-6 p-4 bg-battle-gray border border-gray-700 rounded-lg flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:justify-between">
      <div className="text-white">
        {selectedCount > 0 ? (
          <>
            <span className="font-semibold">{selectedCount}</span> video
            {selectedCount !== 1 ? 's' : ''} selected
          </>
        ) : (
          <span className="text-gray-400">No videos selected</span>
        )}
      </div>
      <div className="flex items-center gap-3">
        <button
          onClick={onAIParseAll}
          disabled={parsing || importing}
          className="px-6 py-3 bg-purple-600 hover:bg-purple-700 disabled:opacity-50 text-white font-bold rounded-lg flex items-center gap-2 transition"
        >
          {parsing ? (
            renderParsingState()
          ) : (
            <>
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              AI Parse All
            </>
          )}
        </button>
        {selectedCount > 0 && (
          <button
            onClick={onImport}
            disabled={importing || parsing}
            className="px-6 py-3 bg-green-600 hover:bg-green-700 disabled:bg-gray-600 text-white font-semibold rounded-lg transition"
          >
            {importing ? 'Importing...' : 'Import Selected'}
          </button>
        )}
      </div>
    </div>
  );
};

export default ImportSummary;
